import lilyLogoMark from '~/assets/images/lily-logo-mark.png';

// Raster Lily brand mark (Figma export); use LilyLogo for the vector flower icon instead.
export function LilyLogoMark({ className }: { className?: string }) {
  return <img alt="" aria-hidden="true" className={className} src={lilyLogoMark} />;
}
